module.exports = __webpack_public_path__ + "components/flag/static/square/pf-2d6863a5b0de6cfb5cfb26838f370295.svg";